module.exports = __webpack_public_path__ + "static/media/jmc-course.9636d921.jpg";